<template>
  <tr class="form-submission-row p-relative">
    <td @click="$emit('click')">
      <span class="font-weight-semi-bold">{{
        isPresent(field) ? field.label : group.title
      }}</span>
    </td>
    <td @click="edit" class="d-flex flex-column align-items-end">
      <template v-if="isPresent(group)">
        <form-submission-group :group="group" :values="values" />
      </template>

      <template v-if="isPresent(field)">
        <div class="w-100 py-1">
          <form-submission-field-value
            :field="field"
            :values="values"
            :is-missable="isMissable"
          />
        </div>
      </template>

      <small
        v-if="currentGroup"
        class="text-grey-50 font-weight-semi-bold pr-2 pt-1"
      >
        Tap To Edit
      </small>
    </td>

    <v-modal
      v-if="isEditing && currentGroup"
      @close="() => (isEditing = false)"
    >
      <template :slot="FORM_GROUP_MODAL">
        <form-template
          :values="values"
          :groups="[currentGroup]"
          :is-missable="isMissable"
          @close="close"
          @input="handleUpdate"
        />
      </template>
    </v-modal>

    <!-- TODO: Remove, I hate this being here -->
    <v-modal v-if="exercise" @close="() => (exercise = null)">
      <template :slot="hash">
        <span>
          <exercise-template
            :id="exercise.id"
            :title="exercise.title"
            :description="exercise.description"
            :banner="exercise.banner"
            :video="exercise.video"
            hide-back
          />
        </span>
      </template>
    </v-modal>
  </tr>
</template>

<script>
import { mapActions } from "vuex"

import { isPresent } from "@/lib/utils"
import { addToHash, removeFromHash } from "@/lib/url-helpers"

import FormTemplate from "@/components/page-templates/FormTemplate"
import FormSubmissionGroup from "@/components/form-submission/RowGroup"
import FormSubmissionFieldValue from "@/components/form-submission/FieldValue"

const FORM_GROUP_MODAL = "#form-group"

export default {
  components: {
    FormTemplate,
    FormSubmissionGroup,
    FormSubmissionFieldValue,
    ExerciseTemplate: () =>
      import("@/components/page-templates/ExerciseTemplate")
  },

  model: {
    prop: "values",
    event: "input"
  },

  props: {
    values: { type: Object, required: true },
    field: { type: Object, default: () => null },
    fieldGroup: { type: Object, default: () => null },
    group: { type: Object, default: () => null }, // TODO: requiredIf
    isMissable: { type: Boolean, default: false }
  },

  data() {
    return {
      isEditing: false,
      isLoadingExercise: false,
      exercise: null,
      FORM_GROUP_MODAL
    }
  },

  computed: {
    hash() {
      return `#exercise-${this._uid}`
    },

    currentGroup() {
      return this.group
        ? this.group
        : this.fieldGroup
        ? { ...this.fieldGroup, form_fields: [this.field] }
        : null
    }
  },

  methods: {
    isPresent,

    ...mapActions("forms", ["fetchExerciseByItemUid"]),

    edit() {
      this.isEditing = true
      this.currentValue = this.value

      this.$router.push(addToHash(this.$route.hash, FORM_GROUP_MODAL))
    },

    handleUpdate(values) {
      this.$emit("input", values)

      this.close()
    },

    close() {
      this.isEditing = false
      this.$router.push(removeFromHash(this.$route.hash, FORM_GROUP_MODAL))
    },

    showExerciseByGroup(group) {
      if (group.uid && group.uid.includes("WorkoutGroupItem")) {
        const k = group.uid.split("-")
        const workoutGroupItemId = parseInt(k[k.length - 1])

        if (isNaN(workoutGroupItemId)) {
          return
        }

        this.isLoadingExercise = true

        this.fetchExerciseByItemUid(workoutGroupItemId)
          .then(exercise => {
            if (exercise && !(this._isBeingDestroyed || this._isDestroyed)) {
              this.exercise = exercise

              this.$router.push(addToHash(this.$route.hash, this.hash))
            }
          })
          .finally(() => {
            this.isLoadingExercise = false
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.form-submission-row {
  > td {
    padding: $size--4 $size--2;
  }

  > td:first-child {
    padding-left: $size--4;
    width: 32%;
  }

  > td:last-child {
    display: flex;
    justify-content: flex-end;
    padding: $size--2 0 $size--3;
  }
}
</style>
